module.exports = __webpack_public_path__ + "static/img/classifyBanner.1eb711f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/classifyBanner.png
// module id = 3j9t
// module chunks = 1